import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { SectionFlourish } from './Ornaments';

export default function Incentives() {
  const videoRef = useRef(null);
  const [endTime, setEndTime] = useState(0);

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setEndTime(Math.max(0, videoRef.current.duration - 2));
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current && endTime > 0) {
      if (videoRef.current.currentTime >= endTime) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }
  };

  const scrollToRsvp = (e) => {
    e.preventDefault();
    document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-burgundy px-4 py-16 md:py-40 relative overflow-hidden min-h-auto">
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden h-full w-full">
        <video 
          ref={videoRef}
          autoPlay 
          muted 
          loop 
          playsInline 
          onLoadedMetadata={handleLoadedMetadata}
          onTimeUpdate={handleTimeUpdate}
          className="w-full h-full object-cover opacity-20"
        >
          <source src="https://ik.imagekit.io/aeu02xvjgn/Midsummer/HRNDZ3271_22.mp4?updatedAt=1782321506255" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-burgundy/60 backdrop-blur-[2px]"></div>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2 }}
        className="max-w-4xl mx-auto text-center relative z-10 border border-estate-gold/30 p-8 md:p-24 bg-burgundy/40 backdrop-blur-md"
      >
        <SectionFlourish className="w-16 md:w-28 h-6 md:h-8 text-estate-gold mx-auto mb-6 md:mb-10" color="#E8A06E" />
        <h2 className="font-serif text-3xl md:text-6xl text-ivory mb-6 md:mb-10 leading-tight px-4">
          Exclusive Booking <br className="hidden md:block"/> Incentives
        </h2>
        <p className="font-sans font-light text-sm md:text-xl text-ivory/80 leading-relaxed mb-4 md:mb-6 max-w-2xl mx-auto px-4">
          Couples who attend The Padua Midsummer Affair and move forward using an event estimate may be eligible for a special wedding enhancement, such as a complimentary signature cocktail, an additional appetizer, or another event-specific offering selected by the Padua team.
        </p>
        <p className="font-sans italic text-[10px] md:text-sm text-floral-apricot tracking-widest mb-10 md:mb-14 px-6 opacity-90">
          Details will be available during the event and may vary by wedding date and celebration.
        </p>
        <a 
          href="#rsvp" 
          onClick={scrollToRsvp}
          className="inline-block border border-floral-apricot text-floral-apricot font-sans text-[10px] md:text-xs uppercase tracking-widest px-8 md:px-12 py-5 md:py-6 hover:bg-floral-apricot hover:text-burgundy transition-all duration-500 shadow-2xl relative z-20"
        >
          Claim Your Complimentary Invitation
        </a>
      </motion.div>
    </section>
  );
}